document.addEventListener("DOMContentLoaded", function () {
  function updateVariantNames() {
    document.querySelectorAll(".variant-name").forEach(function (variantSpan) {
      const newText = variantSpan.textContent.replace(/40g|500g|Instant Wholefood Porridge|Limited Edition/g, "").trim();
      if (variantSpan.textContent !== newText) {
        variantSpan.textContent = newText;
      }
    });
  }

  function handleVisibility() {
    document.querySelectorAll(".product-item").forEach(function(productItem) {
      const decreaseButton = productItem.querySelector(".bb-decrease");
      const quantityInput = productItem.querySelector(".bb-input");
      const increaseButton = productItem.querySelector(".bb-increase");
      decreaseButton.style.display = quantityInput.value > 0 ? "block" : "none";
      quantityInput.style.display = quantityInput.value > 0 ? "block" : "none";
      increaseButton.classList.toggle("darkplus", quantityInput.value <= 0);
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  const debouncedHandleVisibility = debounce(handleVisibility, 50);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        updateVariantNames();
        debouncedHandleVisibility();
      }
    });
  });

  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["value"],
  };

  observer.observe(document.body, config);
});